import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleHeart, ListChecks, Sparkles } from 'lucide-react';
export function About() {
  const features = [{
    icon: MessageCircleHeart,
    title: 'Acompañamiento en español',
    description: 'Te explicamos cada paso de forma simple, clara y humana.'
  }, {
    icon: ListChecks,
    title: 'Proceso más ordenado',
    description: 'Sabes qué sigue y qué necesitas en cada etapa.'
  }, {
    icon: Sparkles,
    title: 'Base profesional para avanzar',
    description: 'Empresa y presencia digital listas desde el inicio.'
  }];
  return <section className="py-24 bg-white" data-id="element-9">
      <div className="max-w-7xl mx-auto px-6" data-id="element-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center" data-id="element-11">
          {/* Left: Annysol's Photo */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-12">
            {/* Decorative background blob */}
            <div className="absolute -inset-6 bg-accent-light/15 rounded-[3rem] blur-2xl -z-10" data-id="element-13" />

            <div className="aspect-square max-w-xs mx-auto rounded-3xl overflow-hidden shadow-soft border border-ink/5 bg-ink relative flex items-center justify-center p-8" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/6SEzMsu2sLH64KLfdCyo8d/INK_PNG.png" alt="Inkova — Business Consulting & Creation" className="w-full h-auto object-contain" data-id="element-15" />
            </div>

            {/* Floating Quote Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="absolute -bottom-6 -right-2 sm:right-2 lg:right-0 bg-white p-5 rounded-3xl shadow-soft border border-ink/5 max-w-xs" data-id="element-16">
              <p className="font-serif italic text-accent text-base leading-snug" data-id="element-17">
                "Creé Inkova para que tengas acceso a la información correcta,
                en tu idioma."
              </p>
              <p className="text-xs font-bold tracking-wider uppercase text-ink/50 mt-2" data-id="element-18">
                — Annysol Navarro
              </p>
            </motion.div>
          </motion.div>

          {/* Right: Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-19">
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-accent mb-4 block" data-id="element-20">
              Sobre la fundadora
            </span>

            <h2 className="font-serif text-4xl md:text-5xl font-bold text-ink leading-tight mb-5" data-id="element-21">
              Quién te <em className="italic text-accent-light" data-id="element-22">acompaña</em>
            </h2>

            <p className="font-serif text-xl md:text-2xl italic text-ink/80 mb-8 leading-snug" data-id="element-23">
              Más claridad. Más acompañamiento. Menos improvisación.
            </p>

            <p className="text-lg text-ink/70 mb-10 leading-relaxed" data-id="element-24">
              Soy Annysol, fundadora de Inkova. Trabajo con emprendedores
              latinos que quieren crear su empresa en EE. UU. con estructura,
              claridad y apoyo real en español desde el inicio.
            </p>

            {/* Feature Blocks */}
            <div className="space-y-5 pt-8 border-t border-ink/10" data-id="element-25">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <motion.div key={i} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: 0.3 + i * 0.1
              }} className="flex items-start gap-4" data-id="element-26">
                    <div className="flex-shrink-0 w-11 h-11 rounded-2xl bg-accent/10 text-accent flex items-center justify-center" data-id="element-27">
                      <Icon className="w-5 h-5" strokeWidth={2} data-id="element-28" />
                    </div>
                    <div data-id="element-29">
                      <h3 className="font-serif font-bold text-lg text-ink mb-1" data-id="element-30">
                        {feature.title}
                      </h3>
                      <p className="text-ink/65 leading-relaxed" data-id="element-31">
                        {feature.description}
                      </p>
                    </div>
                  </motion.div>;
            })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}